import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import s from './Layout.module.css';

type LayoutProps = {
  children: ReactNode;
  className?: string;
  isFullWidth?: boolean;
};

export const Layout = ({ children, className, isFullWidth }: LayoutProps) => (
  <div className={clsx(s.layout, isFullWidth && s.fullWidth, className)}>
    {children}
  </div>
);
